export default "__VITE_ASSET__C27AMdDZ__"